// Authentication configuration for Valeon Strategic Advisory
// v1.0.0-final-staging

const AUTH_CONFIG = {
  // Role-based access credentials
  credentials: {
    founder: {
      password: 'founder123',
      label: 'Founder',
      description: 'Full access to all platform features',
      permissions: ['admin', 'analytics', 'client_data', 'system_config'],
      color: 'from-accent-gold to-yellow-500',
      bgColor: 'bg-accent-gold/10',
      borderColor: 'border-accent-gold/30'
    },
    investor: {
      password: 'investor123', 
      label: 'Investor',
      description: 'Access to analytics and insights',
      permissions: ['analytics', 'reports', 'insights'],
      color: 'from-accent-blue to-blue-500',
      bgColor: 'bg-accent-blue/10',
      borderColor: 'border-accent-blue/30'
    },
    client: {
      password: 'client123',
      label: 'Client', 
      description: 'Client portal and services access',
      permissions: ['consultation', 'reports', 'support'],
      color: 'from-green-400 to-emerald-500',
      bgColor: 'bg-green-400/10',
      borderColor: 'border-green-400/30'
    }
  },

  // Session configuration
  session: {
    // Session duration in milliseconds (24 hours)
    duration: 24 * 60 * 60 * 1000,
    // Storage key for authentication data
    storageKey: 'valeon_auth_session',
    // Auto-logout warning time (5 minutes before expiry)
    warningTime: 5 * 60 * 1000
  },

  // Security settings
  security: {
    // Maximum login attempts before temporary lockout
    maxAttempts: 5,
    // Lockout duration in milliseconds (15 minutes)
    lockoutDuration: 15 * 60 * 1000,
    // Rate limiting for login attempts
    rateLimitWindow: 60 * 1000 // 1 minute
  }
};

// Authentication utility functions
export const validateCredentials = (role, password) => {
  const roleConfig = AUTH_CONFIG.credentials[role];
  if (!roleConfig) return false;
  return roleConfig.password === password;
};

export const getRoleConfig = (role) => {
  return AUTH_CONFIG.credentials[role] || null;
};

export const getAllRoles = () => {
  return Object.keys(AUTH_CONFIG.credentials).map(roleId => ({
    id: roleId,
    ...AUTH_CONFIG.credentials[roleId]
  }));
};

export const hasPermission = (role, permission) => {
  const roleConfig = getRoleConfig(role);
  return roleConfig?.permissions.includes(permission) || false;
};

export const getSessionConfig = () => AUTH_CONFIG.session;
export const getSecurityConfig = () => AUTH_CONFIG.security;

export default AUTH_CONFIG;